import React from "react";

const DEFAULT_SUGGESTIONS = ["Tell me more", "What are the alternatives?", "Can you elaborate?"];

interface FollowUpSuggestionsProps {
  suggestions?: string[];
  onSelect: (text: string) => void;
  visible: boolean;
}

export default function FollowUpSuggestions({
  suggestions,
  onSelect,
  visible,
}: FollowUpSuggestionsProps) {
  if (!visible) return null;

  const items = suggestions && suggestions.length > 0 ? suggestions : DEFAULT_SUGGESTIONS;

  return (
    <div className="flex items-center gap-1.5 flex-wrap mt-2">
      {items.map((text) => (
        <button
          key={text}
          onClick={() => onSelect(text)}
          className="px-2.5 py-1 rounded-full text-[11px] transition-all"
          style={{
            backgroundColor: "var(--c-surface)",
            border: "1px solid var(--c-border)",
            color: "var(--c-text-secondary)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = "var(--c-primary)";
            e.currentTarget.style.color = "var(--c-primary)";
            e.currentTarget.style.backgroundColor = "var(--c-primary-subtle)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "var(--c-border)";
            e.currentTarget.style.color = "var(--c-text-secondary)";
            e.currentTarget.style.backgroundColor = "var(--c-surface)";
          }}
        >
          {text}
        </button>
      ))}
    </div>
  );
}
